import { UnusedSkipTokenOptions, useQuery } from '@tanstack/react-query'
import {
	DepositTransactionResponse,
	GetDepositTransactionsParams,
} from '@/modules/transaction/types'
import { queryDepositTransactionOptions } from './options'

export default function useQueryDepositTransaction(
	payload: GetDepositTransactionsParams,
	options?: UnusedSkipTokenOptions<DepositTransactionResponse>,
) {
	return useQuery(queryDepositTransactionOptions(payload, options))
}
